import React from "react";
import { SerializedError } from "@reduxjs/toolkit";

import { SearchResults, Pager, SearchField, SearchMessage } from "components";
import { IAPIState, IPager, ISearchResult, ISearchSubmitData } from "types";
import { i18nService } from "services";

interface SiteSearchProps {
  initSearchValue?: string;
  onSearch: (data: ISearchSubmitData) => void;
  status: IAPIState;
  error?: SerializedError | null;
  results?: ISearchResult[];
  pager: IPager;
  total?: number;
  hasSearched?: boolean;
  menuOverlayOpen?: boolean;
}

export const SiteSearch: React.FC<SiteSearchProps> = ({
  initSearchValue,
  onSearch,
  status,
  error,
  results,
  pager,
  total,
  hasSearched,
  menuOverlayOpen,
}) => (
  <div className="site-search">
    <div className="site-search__form">
      <SearchField
        id="site-search"
        initSearchValue={initSearchValue}
        isSubmitting={status === IAPIState.pending}
        onSubmit={onSearch}
        menuOverlayOpen={menuOverlayOpen}
      />
      <SearchMessage status={status} hasSearched={hasSearched} total={total} />
      {error && (
        <p className="form-message is-error is-animated" role="alert">
          {i18nService.copy["siteSearch.error"]}
        </p>
      )}
    </div>
    {results && !!results.length && (
      <SearchResults results={results} currentPage={pager.currentPage} />
    )}
    {!!pager.currentPage && pager.totalPages > 1 && (
      <div className="site-search__pager">
        <Pager {...pager} theme="dark" />
      </div>
    )}
  </div>
);
